import React from 'react';
import { FaRegCreditCard } from 'react-icons/fa';
import pure from 'purecss/build/buttons-core-min.css';
import classnames from 'classnames';
import style from './style.scss';

const {
    colbyGiving: { creditCardUrl },
} = window;

export default function CreditCard() {
    return (
        <a
            className={classnames({
                [pure['pure-button']]: true,
                [style.buttonGive]: true,
                [style.creditCard]: true,
                'colby-giving-plugin-buttons-credit-card-button': true,
            })}
            href={`${creditCardUrl}`}
            target="_blank"
            rel="noreferrer noopener"
            aria-label="Credit Card"
        >
            <FaRegCreditCard size="3em" />
        </a>
    );
}
